import type { Group } from '@wlb/shared/types/groups';

/** Group images are typed for RN (ImageSource | string | {uri}); web needs a URL. */
export const resolveGroupImageUrl = (media: Group['groupImage']): string | null => {
  if (!media) return null;
  if (typeof media === 'string') return media.trim() ? media : null;
  if (typeof media === 'object' && 'uri' in media) {
    return typeof media.uri === 'string' && media.uri.trim() ? media.uri : null;
  }
  return null;
};
